import DataTypes from './DataTypes';
import { SECTION_TYPES } from '../../configs/AppConfig';

const initialState = {
  disclosureData: [],
  patientData: [],
  disclosureYears: [],
  patientYears: [],
  disclosureRootSections: [],
  patientRootSections: [],
  disclosureTotal: 0,
  disclosureTotalPages: 1,
  disclosureQueries: {
    page: 1,
    size: 10,
    keyWords: '',
    year: 0,
    rootSectionId: 0
  },
  patientTotal: 0,
  patientTotalPages: 1,
  patientQueries: {
    page: 1,
    size: 10,
    keyWords: '',
    year: 0,
    rootSectionId: 0
  },
  selected: [],
  recordDetail: {},
  recordPatientDetail: {},
  loading: null,
  pdfUpdating: null,
  dataPreviewPDF: null,
  updateRecordProgress: {
    id: null,
    status: null,
    progress: null
  },
  statusUpdate: null
};

export default function dataReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case DataTypes.GET_DISCLOSURE_DATA_SUCCESS:
      newState.disclosureData = [...payload.content];
      newState.disclosureTotal = payload.totalElements;
      if (payload.statusUpdate !== newState.statusUpdate) {
        newState.statusUpdate = payload.statusUpdate;
      }
      return newState;
    case DataTypes.UPDATE_DISCLOSURE_QUERIES:
      newState.disclosureQueries.page = payload.page;
      newState.disclosureQueries.size = payload.size;
      newState.disclosureQueries.keyWords = payload.keyWords;
      newState.disclosureQueries.year = payload.year;
      newState.disclosureQueries.rootSectionId = payload.rootSectionId;
      return newState;
    case DataTypes.GET_PATIENT_DATA_SUCCESS:
      newState.patientData = [...payload.content];
      newState.patientTotal = payload.totalElements;
      if (payload.statusUpdate !== newState.statusUpdate) {
        newState.statusUpdate = payload.statusUpdate;
      }
      return newState;
    case DataTypes.UPDATE_PATIENT_QUERIES:
      newState.patientQueries.page = payload.page;
      newState.patientQueries.size = payload.size;
      newState.patientQueries.keyWords = payload.keyWords;
      newState.patientQueries.year = payload.year;
      newState.patientQueries.rootSectionId = payload.rootSectionId;
      return newState;
    case DataTypes.GET_PDF_PREVIEW_SUCCESS:
      newState.dataPreviewPDF = payload;
      return newState;
    case DataTypes.GET_PDF_PREVIEW_ERROR:
      newState.dataPreviewPDF = null;
      return newState;
    case DataTypes.GET_DATA_RECORD_DETAIL_SUCCESS:
      newState.recordDetail = { ...payload };
      return newState;
    case DataTypes.GET_YEARS_SUCCESS:
      if (payload.type === SECTION_TYPES.DISCLOSURE.value) {
        if (typeof payload.data === 'object') {
          newState.disclosureYears = [...payload.data];
        }
      } else {
        if (typeof payload.data === 'object') {
          newState.patientYears = [...payload.data];
        }
      }
      return newState;
    case DataTypes.GET_ROOT_SECTIONS_SUCCESS:
      if (payload.type === SECTION_TYPES.DISCLOSURE.value) {
        newState.disclosureRootSections = [...payload.data];
      } else {
        newState.patientRootSections = [...payload.data];
      }
      return newState;
    case DataTypes.UPDATE_LOADING:
      newState.loading = payload;
      return newState;
    case DataTypes.PDF_UPDATE_LOADING:
      newState.pdfUpdating = payload;
      return newState;
    case DataTypes.CHECK_UPDATE_DATA_RECORD_PROGRESS_SUCCESS:
      newState.updateRecordProgress = { ...payload };
      return newState;
    case DataTypes.UPDATE_DATA_RECORD_PROGRESS:
      if (payload !== newState.statusUpdate) {
        newState.statusUpdate = payload;
      }
      return newState;
    default:
      newState = state;
      break;
  }

  // return new state
  return newState;
}
